import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-etiquetas-categoria',
  templateUrl: './etiquetas-categoria.component.html',
  styleUrls: ['./etiquetas-categoria.component.css']
})
export class EtiquetaCategoriaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
